import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { AddeditconfigurationgroupComponent } from 'src/app/components/configuration/components/widgets/group/configurationgroup.add.component';
import { RestAPIService } from 'src/app/services/restapi.service';
import { environment } from 'src/environments/environment';
import { GroupModel } from 'src/app/components/configuration/models/groupModel';

@Component({
  selector: 'app-configurationgroup',
  templateUrl: './configurationgroup.component.html'
})
export class ConfigurationgroupComponent implements OnInit {
  public pageSize = 10;
  public currentPage = 0;
  public totalSize = 0;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  configurationGroupList: GroupModel[] = [];
  sortedGroupList: GroupModel[] = [];
  configurationGroupModel: GroupModel = new GroupModel();
  dataSource = new MatTableDataSource<GroupModel>();
  isAdvanceSearchFilter: boolean = false;
  filterKey: string = '';
  currentSort!: Sort;
  

  displayedColumns = ['productCode', 'groupName', 'action'];

  constructor(public _restAPI: RestAPIService, public dialog: MatDialog) {
    this._restAPI.loading  = false;
  }

  ngOnInit() {
      this.getGroupList('');        
  }

  onDisplayFilter(e: any) {
      this.isAdvanceSearchFilter = !this.isAdvanceSearchFilter;
      if(e) {
          e.stopPropagation();
      }
  }
  applyFilter(filterValue: string) {
    if (this.dataSource?.paginator) {
        this.dataSource.paginator.pageIndex = 0;
    }
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    localStorage["configurationGroupFilterValue"] = filterValue;
    this.dataSource.filter = filterValue;
  }

  openGroupDialog (configurationGroupModel: GroupModel): void {
    const dialogRef = this.dialog.open(AddeditconfigurationgroupComponent, {
      width:"700px",
      data: configurationGroupModel
    });

    dialogRef.afterClosed().subscribe(result => {
        this.configurationGroupModel = new GroupModel();
        if (result) {
            this.getGroupList(localStorage["configurationGroupFilterValue"]);
        }
    });
  }

  async getGroupList(filterValue: any) {
    this._restAPI.loading  = true;
    this._restAPI.get<GroupModel[]>(environment.apiURL + 'api/configurationgroup').subscribe({
        next: (results) => {
            this._restAPI.loading  = false;
            this.configurationGroupList = results;
            this.sortedGroupList = this.configurationGroupList.slice();
            this.totalSize = this.sortedGroupList.length;
            this.dataSource.data = results;
            this.dataSource.filter = filterValue;
            this.filterKey = filterValue;
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        },
        error: (error) =>{
            this._restAPI.loading  = false; 
            console.error(error);
        } 
    });
  }

  sortGroups(sort: Sort) {
    if (this.dataSource?.paginator) {
        this.dataSource.paginator.pageIndex = 0;
    }
    this.dataSource.filter = "";
    this.filterKey = "";
    this.currentSort = sort;
    this.pageSize = 10;
    this.currentPage = 0;
    this.sortGroupArray(this.configurationGroupList.slice(), this.currentSort);
    this.dataSource.data = this.sortedGroupList;
  }

  private sortGroupArray(configurationGroups: GroupModel[], sort: Sort): void {
    if (sort === undefined || !sort.active || sort.direction === '') {
    const part = configurationGroups.slice();
        this.sortedGroupList = [];
        for (const item of part) {
          this.sortedGroupList.push(item);
        }
        return;
    }
    this.sortedGroupList = configurationGroups.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        switch (sort.active) {
            case 'productCode': return compare(a.productCode ?? '', b.productCode ?? '', isAsc);
            case 'groupName': return compare(a.groupName ?? '', b.groupName ?? '', isAsc);
            default: return 0;
        }
    });
    const part = this.sortedGroupList.slice();
    this.sortedGroupList = [];
    for (const group of part) {
      this.sortedGroupList.push(group);
    }
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}